declare const chrome: any;

export function loginWithGoogleExtension(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!chrome?.identity) {
      reject(new Error("Chrome Identity API not available"));
      return;
    }

    chrome.identity.getAuthToken({ interactive: true }, (token: string) => {
      if (chrome.runtime.lastError || !token) {
        reject(chrome.runtime.lastError);
      } else {
        resolve(token);
      }
    });
  });
}
